import styled from '@emotion/styled'
import React, { useEffect } from 'react'
import { Platform } from '@/firebase/firestore/Platform'
import { Sex } from '@/firebase/firestore/Sex'
import { VoiceChat } from '@/firebase/firestore/VoiceChats'
import Image from 'next/image'
import fitty from 'fitty'
import { useLocale } from '@/hooks/useLocale'

type Props = {
  targetId: string
  templateColor: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7
  uid: string
  name: string
  sex: Sex
  platform: Array<Platform>
  voiceChat: Array<VoiceChat>
  playStyle: string
  fontColor: string
  fontFamily: string
  playTimeWeekDayBegin: string
  playTimeWeekDayEnd: string
  playTimeWeekEndBegin: string
  playTimeWeekEndEnd: string
  rank: string
  hitokoto: string
  characters: number[]
}

type PokemonUniteRank =
  | 'pokemonUniteBeginner'
  | 'pokemonUniteSuper'
  | 'pokemonUniteHyper'
  | 'pokemonUniteElite'
  | 'pokemonUniteExpert'
  | 'pokemonUniteMaster'

//くぅさんテンプレート
export const PokemonUnite1: React.FC<Props> = ({
  name,
  fontColor,
  fontFamily,
  templateColor,
  voiceChat,
  rank,
  hitokoto,
  characters,
  targetId,
}) => {
  const { t } = useLocale()
  const rankMapLabel: { [key in PokemonUniteRank]: string } = {
    pokemonUniteBeginner: t.ビギナー,
    pokemonUniteSuper: t.スーパー,
    pokemonUniteHyper: t.ハイパー,
    pokemonUniteElite: t.エリート,
    pokemonUniteExpert: t.エキスパート,
    pokemonUniteMaster: t.マスター,
  }
  useEffect(() => {
    fitty('#name', {
      maxSize: 24,
      minSize: 12,
    })
    fitty('#playStyle', {
      maxSize: 16,
      minSize: 12,
    })
    fitty('#pokemonUniteRank', {
      maxSize: 16,
      minSize: 12,
    })
    fitty('#hitokoto', {
      maxSize: 28,
      minSize: 14,
    })
  }, [])
  return (
    <ProfileContainer>
      <ProfileInner id={targetId} fontFamily={fontFamily} color={fontColor}>
        <Image
          width="1200"
          height="1600"
          priority={true}
          unoptimized={true}
          src={`/static/images/profiles/pokemonUnite1/${templateColor}-min.jpeg`}
          alt={`ポケモンユナイト自己紹介カード ${templateColor}`}
        />
        <Name>
          <span id="name">{name}</span>
        </Name>
        <VCText color={fontColor}>
          {voiceChat.includes(0) && ' Skype '}
          {voiceChat.includes(1) && ' LINE '}
          {voiceChat.includes(2) && ' プレステ '}
          {voiceChat.includes(3) && ' Discord '}
          {voiceChat.includes(5) && ' Switch '}
        </VCText>
        {characters.includes(0) && <Character0 />}
        {characters.includes(1) && <Character1 />}
        {characters.includes(2) && <Character2 />}
        {characters.includes(3) && <Character3 />}
        {characters.includes(4) && <Character4 />}
        {characters.includes(5) && <Character5 />}
        {characters.includes(6) && <Character6 />}
        {characters.includes(7) && <Character7 />}
        {characters.includes(8) && <Character8 />}
        {characters.includes(9) && <Character9 />}
        {characters.includes(10) && <Character10 />}
        {characters.includes(11) && <Character11 />}
        {characters.includes(12) && <Character12 />}
        {characters.includes(13) && <Character13 />}
        {characters.includes(14) && <Character14 />}
        {characters.includes(15) && <Character15 />}
        {characters.includes(16) && <Character16 />}
        {characters.includes(17) && <Character17 />}
        {characters.includes(18) && <Character18 />}
        {characters.includes(19) && <Character19 />}
        {characters.includes(20) && <Character20 />}
        {characters.includes(21) && <Character21 />}
        {characters.includes(22) && <Character22 />}
        {characters.includes(23) && <Character23 />}
        {characters.includes(24) && <Character24 />}
        {characters.includes(25) && <Character25 />}
        {characters.includes(26) && <Character26 />}
        {characters.includes(27) && <Character27 />}
        {characters.includes(28) && <Character28 />}
        {characters.includes(29) && <Character29 />}
        {characters.includes(30) && <Character30 />}
        {characters.includes(31) && <Character31 />}
        {characters.includes(32) && <Character32 />}
        {characters.includes(33) && <Character33 />}
        {characters.includes(34) && <Character34 />}
        {characters.includes(35) && <Character35 />}
        {characters.includes(36) && <Character36 />}
        {characters.includes(37) && <Character37 />}
        {characters.includes(38) && <Character38 />}
        {characters.includes(39) && <Character39 />}
        {characters.includes(40) && <Character40 />}
        {characters.includes(41) && <Character41 />}
        <Hitokoto>
          <span id={'hitokoto'}>{hitokoto}</span>
        </Hitokoto>
        <Rank>
          <span id={'pokemonUniteRank'}>{rankMapLabel[rank]}</span>
        </Rank>
      </ProfileInner>
    </ProfileContainer>
  )
}

const ProfileContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #4c4c4c;
`

const ProfileInner = styled.div<{ fontFamily: string; color: string }>`
  position: relative;
  line-height: 0;
  width: 280px;
  * {
    line-height: 1;
    font-family: ${({ fontFamily }) => fontFamily};
    color: ${({ color }) => color};
  }
`

const Name = styled.div`
  position: absolute;
  top: 8.5%;
  left: 5.3%;
  width: 40%;
  height: 14%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    letter-spacing: -2px;
    font-weight: bold;
  }
`

const VCText = styled.div`
  position: absolute;
  top: 23.3%;
  left: 28%;
  text-align: center;
  width: 18%;
  font-size: 20px;
  font-weight: bold;
  word-break: break-all;
  line-height: 13px;
`

const Rank = styled.span`
  position: absolute;
  top: 23%;
  left: 4%;
  text-align: center;
  width: 18%;
  font-weight: bold;
  word-break: break-all;
  line-height: 13px;
`

const CharacterBase = styled.div`
  position: absolute;
  top: 30.8%;
  left: 5.3%;
  border-style: solid;
  border-width: 4px;
  border-radius: 50%;
  width: 35px;
  height: 35px;
`

const Character0 = styled(CharacterBase)``
const Character1 = styled(CharacterBase)`
  left: 18%;
`
const Character2 = styled(CharacterBase)`
  left: 30.5%;
`
const Character3 = styled(CharacterBase)`
  left: 43.6%;
`
const Character4 = styled(CharacterBase)`
  left: 56.8%;
`

const Character5 = styled(CharacterBase)`
  left: 69%;
`
const Character6 = styled(CharacterBase)`
  left: 82%;
`
const Character7 = styled(CharacterBase)`
  top: 40.8%;
  left: 5.3%;
`
const Character8 = styled(CharacterBase)`
  top: 40.8%;
  left: 18%;
`
const Character9 = styled(CharacterBase)`
  top: 40.8%;
  left: 30.5%;
`

const Character10 = styled(CharacterBase)`
  top: 40.8%;
  left: 43.6%;
`

const Character11 = styled(CharacterBase)`
  top: 40.8%;
  left: 56.8%;
`

const Character12 = styled(CharacterBase)`
  top: 40.8%;
  left: 69%;
`

const Character13 = styled(CharacterBase)`
  top: 40.8%;
  left: 82%;
`

const Character14 = styled(CharacterBase)`
  top: 50.5%;
  left: 5.3%;
`

const Character15 = styled(CharacterBase)`
  top: 50.5%;
  left: 18%;
`

const Character16 = styled(CharacterBase)`
  top: 50.5%;
  left: 30.5%;
`

const Character17 = styled(CharacterBase)`
  top: 50.5%;
  left: 43.6%;
`

const Character18 = styled(CharacterBase)`
  top: 50.5%;
  left: 56.8%;
`

const Character19 = styled(CharacterBase)`
  top: 50.5%;
  left: 69%;
`
const Character20 = styled(CharacterBase)`
  top: 50.5%;
  left: 82%;
`
const Character21 = styled(CharacterBase)`
  top: 60.5%;
  left: 5.3%;
`

const Character22 = styled(CharacterBase)`
  top: 60.5%;
  left: 18%;
`

const Character23 = styled(CharacterBase)`
  top: 60.5%;
  left: 30.5%;
`

const Character24 = styled(CharacterBase)`
  top: 60.5%;
  left: 43.6%;
`

const Character25 = styled(CharacterBase)`
  top: 60.5%;
  left: 56.8%;
`

const Character26 = styled(CharacterBase)`
  top: 60.5%;
  left: 69%;
`
const Character27 = styled(CharacterBase)`
  top: 60.5%;
  left: 82%;
`
const Character28 = styled(CharacterBase)`
  top: 70%;
  left: 5.3%;
`

const Character29 = styled(CharacterBase)`
  top: 70%;
  left: 18%;
`

const Character30 = styled(CharacterBase)`
  top: 70%;
  left: 30.5%;
`

const Character31 = styled(CharacterBase)`
  top: 70%;
  left: 43.6%;
`

const Character32 = styled(CharacterBase)`
  top: 70%;
  left: 56.8%;
`

const Character33 = styled(CharacterBase)`
  top: 70%;
  left: 69.5%;
`
const Character34 = styled(CharacterBase)`
  top: 70%;
  left: 82%;
`
const Character35 = styled(CharacterBase)`
  top: 80%;
  left: 5.3%;
`

const Character36 = styled(CharacterBase)`
  top: 80%;
  left: 18%;
`

const Character37 = styled(CharacterBase)`
  top: 80%;
  left: 30.5%;
`

const Character38 = styled(CharacterBase)`
  top: 80%;
  left: 43.6%;
`

const Character39 = styled(CharacterBase)`
  top: 80%;
  left: 56.8%;
`

const Character40 = styled(CharacterBase)`
  top: 80%;
  left: 69.8%;
`

const Character41 = styled(CharacterBase)`
  top: 80%;
  left: 82%;
`

const Hitokoto = styled.div`
  position: absolute;
  top: 10%;
  left: 55%;
  width: 40%;
  height: 20%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    letter-spacing: -2px;
    font-weight: bold;
    line-height: 1.2;
  }
`
